@if (loading$ | async) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
}

@if ((loading$ | async) === false) {
  <form [formGroup]="documentLibraryForm">
    <div class="border-b bg-aux-gray-light px-8 py-8">
      <h1 class="mb-3.5 h-11 text-2xl font-bold text-aux-gray-darkest">Document Library</h1>
      <aux-document-library-filters
        [form]="documentLibraryForm"
        [onFilterChange]="onFilterChange"
      />
    </div>
    <div class="px-8 pb-10 pt-6">
      <div class="flex items-center justify-between pb-6">
        <aux-button
          variant="secondary"
          label="Bulk Edit"
          icon="Pencil"
          [disabled]="isBulkApplyButtonDisabled$ | async"
          [onClick]="onBulkApplyButtonClick"
        />
        <div class="flex">
          <aux-export-excel-button
            [gridAPI]="documentLibraryComponent.gridAPI"
            [excelOptions]="documentsPageService.excelOptions"
            [getDynamicExcelParamsCallback]="documentsPageService.getDynamicExcelParams"
            pendoTag="documents-excel-export-button"
          />
          <aux-button
            variant="primary"
            class="pl-4"
            label="Upload Documents"
            icon="Plus"
            [disableLoading]="true"
            [onClick]="onDocumentUploadClick.bind(this)"
          />
        </div>
      </div>
      <aux-document-library
        #documentLibraryComponent
        [formGroup]="documentLibraryForm"
        [isExternalFilterPresent]="hasFilters"
        [doesExternalFilterPass]="shouldRowBeShown"
        [inputChangeHandler]="updateGridData"
        [rowSelectedHandler]="onRowSelected"
        [removedRows$]="removedRows$"
        (deleteRowEvent)="onRemoveRow($event)"
        (rollbackDeleteRowEvent)="onRollbackDeleteRow($event)"
        (rowDataChangedEvent)="selectRows()"
        (filterChange)="filterChange($event)"
      />
    </div>
  </form>
}

@if (hasChanges$ | async) {
  <aux-save-changes
    [onSaveChanges]="saveAllChanges"
    [showDiscardChangesBtn]="true"
    (cancel)="reset()"
  />
}
